import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoginForm from "./components/LoginForm";
import ConsumerList from "./components/ConsumerList";
import ResetPasswordForm from "./components/ResetPasswordForm";
import QuotationPage from "./components/QuotationPage";
import ConsumerDashboard from "./pages/ConsumerDashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("Token"));
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [userName, setUserName] = useState(localStorage.getItem("User") || "Admin");
  const [userRole, setUserRole] = useState(localStorage.getItem("Role") || "");

  useEffect(() => {
    setUserName(localStorage.getItem("User") || "Admin");
    setUserRole(localStorage.getItem("Role") || "");
  }, [isLoggedIn]);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setShowResetPassword(false);
  };

  const handleLoginSuccess = (loginName, role) => {
    setUserName(loginName);
    setUserRole(role);
    setIsLoggedIn(true);
    setShowResetPassword(false);
  };

  const handleResetPasswordSuccess = () => {
    setShowResetPassword(false);
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative">
      {isLoggedIn && (
        <Header
          onLogout={handleLogout}
          userName={userName}
          onResetPassword={() => setShowResetPassword(true)}
        />
      )}

      <div className="flex-grow p-4">
        <Routes>
          {isLoggedIn ? (
            <>
              {/* ✅ DASHBOARD AS DEFAULT */}
              <Route path="/" element={<ConsumerDashboard />} />

              {/* Consumers List */}
              <Route path="/consumers" element={<ConsumerList />} />

              {/* Quotations */}
              <Route path="/quotations/*" element={<QuotationPage />} />

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              <Route
                path="/"
                element={
                  <LoginForm
                    onLogin={handleLoginSuccess}
                    onForgotPassword={() => setShowResetPassword(true)}
                  />
                }
              />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </div>

      <Footer />

      {/* 🔐 Reset Password Modal */}
      {showResetPassword && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 w-full max-w-md shadow-lg relative">
            <button
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900"
              onClick={() => setShowResetPassword(false)}
            >
              ✕
            </button>
            <ResetPasswordForm
              onBackToLogin={() => setShowResetPassword(false)}
              onSuccess={handleResetPasswordSuccess}
            />
          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
